import {Link} from "react-router-dom";
import React, {useEffect, useState} from "react";
import '../../../assets/css/biography.css'
import ReactModal from "react-modal";
import api from '../../../services/api'

/**
 * biography_about에서민 사용하는 태그 팝업 컴포넌트
 *
 */

const TagePop = ({closeTagPopup}) => {

    // TODO 모든 api 키워드 수신하기

    return (
        <>
            <h1>나는 태그 팝업</h1>
            <button onClick={closeTagPopup}>닫기 버튼</button>
        </>
    )
}

/**
 * 회고록에 대한 소개
 *
 */
const BiographyAbout = () => {

    const [isTagPopupOpen, setIsTagPopupOpen] = useState(false);
    const [keywords, setKeywords] = useState([]);
    const [biographyItems, setBiographyItems] = useState([]);
    const [showModal1, setShowModal1] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const handleOpenModal1 = () => {
        setShowModal1(true);
    };

    const handleCloseModal1 = () => {
        setShowModal1(false);
    };

    // const biographyItems = ["사람", "학교", "입학", "진학", "event", "사람", "학교", "입학", "진학", "event"];

    useEffect(() => {
        const getTags = async () => {
            try {
                const response = await api.get(`/get_events_by_category/biography-education`);
                if (response.status === 200) {
                    const items = response.data.data.map((item) => ({
                        event_id: item.event_id,
                        event_type: item.event_type,
                        event_category: item.event_category,
                        event_tag: item.event_tag
                    }));

                    /**
                     * event_id 를 이용하여 해당 이벤트의 책 수를 가져옴
                     * 시간도 많이 걸리고 최초 events 데이터를 가져올때 처리하는것으로 변경 요청해야 함.
                     */
                    // const countPromises = items.map(async (item) => {
                    //     try {
                    //         const countResponse = await api.get(`/get_books_with_paragraphs_by_event_id/${item.event_id}`);
                    //         return { ...item, event_count: countResponse.data.event.books.length };
                    //     } catch (error) {
                    //         console.error(`이벤트 ID ${item.event_id} 의 카운트 데이터를 가져오는 중 오류 발생:`, error);
                    //         return { ...item, event_count: 0 }; // 오류 발생 시 기본값 0
                    //     }
                    // });
                    //
                    // // 모든 카운트 데이터를 가져온 후 상태 업데이트
                    // const itemsWithCount = await Promise.all(countPromises);
                    setBiographyItems(items);
                    setIsLoading(false);
                }
            } catch (error) {
                console.error("경험(회고록) 태그 수신 오류:", error); // 에러 로깅
                setBiographyItems([]);
            }
        };

        getTags();
    }, []);

    return (
        <>
            <main id="contents">
                <div className="sub-content">
                    <div className="biography-wrap">
                        <div className="cont-top">
                            <div className="w-set">
                                <div className="title-wrap">
                                    <h2 className="title batang">경험</h2>
                                    <p className="text">조선제학교일람을 통해 <br/>근대학교의 변천사를 확인할 수 있습니다.</p>
                                </div>
                            </div>
                        </div>
                        <div className="cont-btm">
                            <div className="w-set">
                                <div className="about-wrap">
                                    <div className="video-wrap">
                                        <div className="video-box type-wide">
                                            <img src="/images/search/biography_search_img1.png" alt="공도공립보통학교(1936) - 교육박물관 소장" />
                                        </div>
                                        <p className="caption">공도공립보통학교(1936) - 교육박물관 소장</p>
                                    </div>
                                    <div className="text-wrap">
                                        <p className="sub-tit">회고록에 등장하는 교육경험</p>
                                        <p>
                                            한국근대교육사연구센터(이하 센터)는 회고록을 통해 과거의 인물들이 남긴 기억을 이어주는 역할을 하고 있습니다.
                                        </p>
                                        <p>
                                            센터에서는 회고록 속 이야기를 입학, 졸업, 시험 등과 같은 교육제도와 연결하거나, 교사와 학생 사이의 소중한 경험 혹은 친구들과의 우정
                                            등을 교직, 교우, 사제 관계로 풀어내는데 이렇게 회고록을 살펴보면, 그동안 잘 알려지지 않았던 사람들의 교육적 발 자취와 삶을 엿볼 수
                                            있습니다.
                                        </p>
                                        <p>
                                            회고록에는 한 학교에서 성장한 학생들과 그들을 가르쳤던 교사들의 이야기, 다양한 직업을 거치 며 교육 분야에서 노력했던 사람들의 이야기가
                                            담겨 있으며, 개인의 여정을 담고 있는 회고록은 평범한 사람들의 이야기를 통해 근현대 역사를 다시금 되새겨보는 시간을 갖게 할 것입니다.
                                        </p>
                                        <p>
                                            저희는 과거와 현재를 이어주는 회고록을 들여다보며, 우리네의 삶 속에서 겪었던 다양한 교육적 경험을 드러내기 위해 노력하고 있습니다.
                                        </p>
                                    </div>
                                </div>
                                <div className="keyword-wrap">
                                    <div className="text-wrap">
                                        <p className="sub-tit">교육경험 키워드</p>
                                        <p className="sub-text">한국근대교육사연구센터에서 소장하고 있는 600권의 도서 세부정보를 제공합니다.</p>
                                        <p className="sub-text">개별 회고록 책 안의 교육경험에 관한 내용을 구체적으로 살펴보고 싶으시다면, 아래의 태그에서 세부
                                            검색을 해보세요.</p>
                                    </div>
                                    <div className="keyword-search">
                                        <div className="hashtag-wrap">
                                            {isLoading && (
                                                <div className="load-wrap">
                                                    <div className="load-box">
                                                        <div className="square"></div>
                                                        <div className="square"></div>
                                                        <div className="square"></div>
                                                        <div className="square"></div>
                                                    </div>
                                                </div>
                                            )}
                                            <ul>
                                                {biographyItems.map((item, index) => (
                                                    <li key={index}><Link to={`/biography_list/${item.event_id}#${item.event_tag}`}>{item.event_tag}</Link></li>
                                                ))}
                                            </ul>
                                            <button type="button" className="more-btn" onClick={handleOpenModal1}>더보기</button>
                                        </div>
                                        <div className="btn-wrap type-center">
                                            <Link to="/archive/biography" className="btn btn-i">전체 회고록 목록보기</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <ReactModal
                isOpen={showModal1}
                onRequestClose={handleCloseModal1}
                contentLabel="First Modal"
                style={{
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.5)", // 배경색
                        zIndex: 1000, // 첫 번째 모달의 z-index
                    },
                    content: {
                        width: "400px",
                        height: "400px",
                        margin: "auto",
                        borderRadius: "10px",
                    },
                }}
            >
                <div
                    className="wbz-popup-cont is-template size-m"
                    id="biographyPopup"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <div className="popup-header">
                        <b className="popup-title">교육경험 키워드 <span className="sub-tit">(태그명 클릭 시 세부 검색이 가능합니다.)</span></b>
                        <button type="button" className="popup-close" onClick={handleCloseModal1}>닫기</button>
                    </div>
                    <div className="popup-cont">
                        <div className="list-table">
                            <div className="list-wrap">
                                <ul className="list-cont">
                                    {biographyItems.map((item, index) => (
                                        <li className="list-item" key={index}><Link to={`/biography_list/${item.event_id}`} className="tag">{item.event_tag}</Link></li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal>
        </>
    );
}
export default BiographyAbout;